var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column gap-20 align-items-center" },
    [
      _c("h1", { staticClass: "m-0" }, [
        _vm._v(
          _vm._s(_vm._f("trans")("Choose your plan or package to continue"))
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-center gap-20 flex-wrap",
          staticStyle: { padding: "20px 0" },
        },
        [
          _c("div", { staticClass: "pricing-card-container" }, [
            _c("div", { staticClass: "pricing-card bg-white" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between flex-wrap" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex gap-5",
                      staticStyle: { height: "max-content" },
                    },
                    [
                      _c("div", { staticClass: "icon-box" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewbox: "0 0 16 16",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M8.00016 3.33331C9.72816 3.33331 11.3242 3.64331 12.5135 4.17198C13.1068 4.43598 13.6295 4.76731 14.0115 5.16931C14.3975 5.57331 14.6668 6.08131 14.6668 6.66665V9.33331C14.6668 9.91865 14.3975 10.426 14.0115 10.8306C13.6295 11.2326 13.1075 11.564 12.5135 11.828C11.3242 12.3566 9.72816 12.6666 8.00016 12.6666C6.27216 12.6666 4.67616 12.3566 3.48683 11.828C2.8935 11.564 2.37083 11.2326 1.98883 10.8306C1.60283 10.4266 1.3335 9.91865 1.3335 9.33331V6.66665C1.3335 6.08131 1.60283 5.57398 1.98883 5.16931C2.37083 4.76731 2.89283 4.43598 3.48683 4.17198C4.67616 3.64331 6.27216 3.33331 8.00016 3.33331ZM13.3335 8.71998C13.0835 8.88398 12.8068 9.03065 12.5135 9.16131C11.3242 9.68998 9.72816 9.99998 8.00016 9.99998C6.27216 9.99998 4.67616 9.68998 3.48683 9.16131C3.2021 9.03645 2.92788 8.88886 2.66683 8.71998V9.33331C2.66683 9.48465 2.7335 9.67865 2.95483 9.91198C3.1795 10.148 3.53616 10.3913 4.02816 10.61C5.01083 11.0466 6.41483 11.3333 8.00016 11.3333C9.58616 11.3333 10.9895 11.0466 11.9722 10.61C12.4642 10.3913 12.8208 10.148 13.0455 9.91198C13.2675 9.67865 13.3335 9.48465 13.3335 9.33331V8.71998ZM8.00016 4.66665C6.41416 4.66665 5.01083 4.95331 4.02816 5.38998C3.53616 5.60865 3.1795 5.85198 2.95483 6.08798C2.73283 6.32131 2.66683 6.51531 2.66683 6.66665C2.66683 6.81798 2.7335 7.01198 2.95483 7.24531C3.1795 7.48131 3.53616 7.72465 4.02816 7.94331C5.01083 8.37998 6.41483 8.66665 8.00016 8.66665C9.58616 8.66665 10.9895 8.37998 11.9722 7.94331C12.4642 7.72465 12.8208 7.48131 13.0455 7.24531C13.2675 7.01198 13.3335 6.81798 13.3335 6.66665C13.3335 6.51531 13.2668 6.32131 13.0455 6.08798C12.8208 5.85198 12.4642 5.60865 11.9722 5.38998C10.9895 4.95398 9.5855 4.66665 8.00016 4.66665Z",
                                fill: "#2E2E2E",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("strong", { staticClass: "font-size-125" }, [
                        _vm._v(
                          _vm._s(_vm.quota480.quota) +
                            " " +
                            _vm._s(_vm._f("trans")("Credits"))
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "end" } }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.productPriceString(_vm.quota480.price))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("trans")("Pay As You Go"))),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Occasional Use")))]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column gap-20" }, [
                _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Ideal for those who need sporadic access. Enjoy flexibility with pay-as-you-go pricing."
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Perfect for occasional tasks or projects without the commitment of a subscription."
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex gap-10" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "22",
                        viewbox: "0 0 24 22",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53024C1 4.51603 1.36009 3.64885 2.08026 2.92867C2.80043 2.2085 3.66761 1.84842 4.68182 1.84842H15.3182C15.8551 1.84842 16.3537 1.95495 16.8139 2.16802C16.9418 2.22768 17.0185 2.32569 17.044 2.46206C17.0696 2.60694 17.0312 2.73052 16.929 2.83279L16.3026 3.45921C16.2173 3.54444 16.1193 3.58706 16.0085 3.58706C15.983 3.58706 15.9446 3.57853 15.8935 3.56149C15.6974 3.51035 15.5057 3.48478 15.3182 3.48478H4.68182C4.11932 3.48478 3.63778 3.68507 3.23722 4.08564C2.83665 4.4862 2.63636 4.96774 2.63636 5.53024V16.1666C2.63636 16.7291 2.83665 17.2106 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2106 17.3636 16.7291 17.3636 16.1666V12.9194C17.3636 12.8086 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84984L11.5469 16.2561C11.3423 16.4606 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4606 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0302C4.28551 9.74899 4.38778 9.50609 4.59233 9.30154L5.99858 7.89529C6.20312 7.69075 6.44602 7.58848 6.72727 7.58848C7.00852 7.58848 7.25142 7.69075 7.45597 7.89529L10.8182 11.2575L19.0895 2.9862C19.294 2.78166 19.5369 2.67939 19.8182 2.67939C20.0994 2.67939 20.3423 2.78166 20.5469 2.9862L21.9531 4.39245C22.1577 4.597 22.2599 4.8399 22.2599 5.12115C22.2599 5.4024 22.1577 5.64529 21.9531 5.84984Z",
                          fill: "#1266F1",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", { staticClass: "font-size-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Up to %creditCount% tasks",
                          { "%creditCount%": _vm.quota480.quota },
                          "general"
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex gap-10" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "22",
                        viewbox: "0 0 24 22",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53024C1 4.51603 1.36009 3.64885 2.08026 2.92867C2.80043 2.2085 3.66761 1.84842 4.68182 1.84842H15.3182C15.8551 1.84842 16.3537 1.95495 16.8139 2.16802C16.9418 2.22768 17.0185 2.32569 17.044 2.46206C17.0696 2.60694 17.0312 2.73052 16.929 2.83279L16.3026 3.45921C16.2173 3.54444 16.1193 3.58706 16.0085 3.58706C15.983 3.58706 15.9446 3.57853 15.8935 3.56149C15.6974 3.51035 15.5057 3.48478 15.3182 3.48478H4.68182C4.11932 3.48478 3.63778 3.68507 3.23722 4.08564C2.83665 4.4862 2.63636 4.96774 2.63636 5.53024V16.1666C2.63636 16.7291 2.83665 17.2106 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2106 17.3636 16.7291 17.3636 16.1666V12.9194C17.3636 12.8086 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84984L11.5469 16.2561C11.3423 16.4606 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4606 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0302C4.28551 9.74899 4.38778 9.50609 4.59233 9.30154L5.99858 7.89529C6.20312 7.69075 6.44602 7.58848 6.72727 7.58848C7.00852 7.58848 7.25142 7.69075 7.45597 7.89529L10.8182 11.2575L19.0895 2.9862C19.294 2.78166 19.5369 2.67939 19.8182 2.67939C20.0994 2.67939 20.3423 2.78166 20.5469 2.9862L21.9531 4.39245C22.1577 4.597 22.2599 4.8399 22.2599 5.12115C22.2599 5.4024 22.1577 5.64529 21.9531 5.84984Z",
                          fill: "#1266F1",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", { staticClass: "font-size-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Up to %aiTasks% AI-supported tasks",
                          { "%aiTasks%": 60 },
                          "general"
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "pricing-card-large-button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToChoosePayment("payg", 480)
                    },
                  },
                },
                [
                  _vm.isStatusLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-center",
                        },
                        [
                          _c("span", {
                            staticClass: "spin-circle-basic spin-circle-175",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStatusDone
                    ? _c("strong", { staticClass: "font-size-125" }, [
                        _vm._v(_vm._s(_vm._f("trans")("Buy Now"))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "12",
                        viewBox: "0 0 15 12",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M14.0373 6.70597C14.4278 6.3155 14.4278 5.68137 14.0373 5.2909L9.03928 0.292854C8.6488 -0.0976181 8.01468 -0.0976181 7.6242 0.292854C7.23373 0.683327 7.23373 1.31745 7.6242 1.70793L10.9198 5.00039H1.33604C0.783126 5.00039 0.336426 5.44709 0.336426 6C0.336426 6.55291 0.783126 6.99961 1.33604 6.99961H10.9167L7.62733 10.2921C7.23685 10.6825 7.23685 11.3167 7.62733 11.7071C8.0178 12.0976 8.65193 12.0976 9.0424 11.7071L14.0404 6.7091L14.0373 6.70597Z",
                          fill: "white",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "pricing-card-container pricing-card-container-most-popular",
            },
            [
              _c("strong", { staticClass: "most-popular-text" }, [
                _vm._v(_vm._s(_vm._f("trans")("Most Popular"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pricing-card bg-white" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between flex-wrap" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex gap-5",
                        staticStyle: { height: "max-content" },
                      },
                      [
                        _c("div", { staticClass: "icon-box" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                viewbox: "0 0 16 16",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d: "M8.00016 3.33331C9.72816 3.33331 11.3242 3.64331 12.5135 4.17198C13.1068 4.43598 13.6295 4.76731 14.0115 5.16931C14.3975 5.57331 14.6668 6.08131 14.6668 6.66665V9.33331C14.6668 9.91865 14.3975 10.426 14.0115 10.8306C13.6295 11.2326 13.1075 11.564 12.5135 11.828C11.3242 12.3566 9.72816 12.6666 8.00016 12.6666C6.27216 12.6666 4.67616 12.3566 3.48683 11.828C2.8935 11.564 2.37083 11.2326 1.98883 10.8306C1.60283 10.4266 1.3335 9.91865 1.3335 9.33331V6.66665C1.3335 6.08131 1.60283 5.57398 1.98883 5.16931C2.37083 4.76731 2.89283 4.43598 3.48683 4.17198C4.67616 3.64331 6.27216 3.33331 8.00016 3.33331ZM13.3335 8.71998C13.0835 8.88398 12.8068 9.03065 12.5135 9.16131C11.3242 9.68998 9.72816 9.99998 8.00016 9.99998C6.27216 9.99998 4.67616 9.68998 3.48683 9.16131C3.2021 9.03645 2.92788 8.88886 2.66683 8.71998V9.33331C2.66683 9.48465 2.7335 9.67865 2.95483 9.91198C3.1795 10.148 3.53616 10.3913 4.02816 10.61C5.01083 11.0466 6.41483 11.3333 8.00016 11.3333C9.58616 11.3333 10.9895 11.0466 11.9722 10.61C12.4642 10.3913 12.8208 10.148 13.0455 9.91198C13.2675 9.67865 13.3335 9.48465 13.3335 9.33331V8.71998ZM8.00016 4.66665C6.41416 4.66665 5.01083 4.95331 4.02816 5.38998C3.53616 5.60865 3.1795 5.85198 2.95483 6.08798C2.73283 6.32131 2.66683 6.51531 2.66683 6.66665C2.66683 6.81798 2.7335 7.01198 2.95483 7.24531C3.1795 7.48131 3.53616 7.72465 4.02816 7.94331C5.01083 8.37998 6.41483 8.66665 8.00016 8.66665C9.58616 8.66665 10.9895 8.37998 11.9722 7.94331C12.4642 7.72465 12.8208 7.48131 13.0455 7.24531C13.2675 7.01198 13.3335 6.81798 13.3335 6.66665C13.3335 6.51531 13.2668 6.32131 13.0455 6.08798C12.8208 5.85198 12.4642 5.60865 11.9722 5.38998C10.9895 4.95398 9.5855 4.66665 8.00016 4.66665Z",
                                  fill: "#2E2E2E",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("strong", { staticClass: "font-size-125" }, [
                          _vm._v(
                            _vm._s(_vm.subscription2800.monthly_credits) +
                              " " +
                              _vm._s(_vm._f("trans")("Credits"))
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "text-align": "end" } }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.productPriceString(_vm.subscription2800.price)
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("trans")("Monthly Subscription"))),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Regular Use")))]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-column gap-20" }, [
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "For consistent usage patterns. Unlock benefits designed for regular users."
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "m-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "Save with a monthly subscription plan, ensuring access whenever you need it."
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex gap-10" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "22",
                          viewbox: "0 0 24 22",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53024C1 4.51603 1.36009 3.64885 2.08026 2.92867C2.80043 2.2085 3.66761 1.84842 4.68182 1.84842H15.3182C15.8551 1.84842 16.3537 1.95495 16.8139 2.16802C16.9418 2.22768 17.0185 2.32569 17.044 2.46206C17.0696 2.60694 17.0312 2.73052 16.929 2.83279L16.3026 3.45921C16.2173 3.54444 16.1193 3.58706 16.0085 3.58706C15.983 3.58706 15.9446 3.57853 15.8935 3.56149C15.6974 3.51035 15.5057 3.48478 15.3182 3.48478H4.68182C4.11932 3.48478 3.63778 3.68507 3.23722 4.08564C2.83665 4.4862 2.63636 4.96774 2.63636 5.53024V16.1666C2.63636 16.7291 2.83665 17.2106 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2106 17.3636 16.7291 17.3636 16.1666V12.9194C17.3636 12.8086 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84984L11.5469 16.2561C11.3423 16.4606 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4606 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0302C4.28551 9.74899 4.38778 9.50609 4.59233 9.30154L5.99858 7.89529C6.20312 7.69075 6.44602 7.58848 6.72727 7.58848C7.00852 7.58848 7.25142 7.69075 7.45597 7.89529L10.8182 11.2575L19.0895 2.9862C19.294 2.78166 19.5369 2.67939 19.8182 2.67939C20.0994 2.67939 20.3423 2.78166 20.5469 2.9862L21.9531 4.39245C22.1577 4.597 22.2599 4.8399 22.2599 5.12115C22.2599 5.4024 22.1577 5.64529 21.9531 5.84984Z",
                            fill: "#1266F1",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("strong", { staticClass: "font-size-125" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "Up to %creditCount% tasks",
                            {
                              "%creditCount%":
                                _vm.subscription2800.monthly_credits,
                            },
                            "general"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex gap-10" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "22",
                          viewbox: "0 0 24 22",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53024C1 4.51603 1.36009 3.64885 2.08026 2.92867C2.80043 2.2085 3.66761 1.84842 4.68182 1.84842H15.3182C15.8551 1.84842 16.3537 1.95495 16.8139 2.16802C16.9418 2.22768 17.0185 2.32569 17.044 2.46206C17.0696 2.60694 17.0312 2.73052 16.929 2.83279L16.3026 3.45921C16.2173 3.54444 16.1193 3.58706 16.0085 3.58706C15.983 3.58706 15.9446 3.57853 15.8935 3.56149C15.6974 3.51035 15.5057 3.48478 15.3182 3.48478H4.68182C4.11932 3.48478 3.63778 3.68507 3.23722 4.08564C2.83665 4.4862 2.63636 4.96774 2.63636 5.53024V16.1666C2.63636 16.7291 2.83665 17.2106 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2106 17.3636 16.7291 17.3636 16.1666V12.9194C17.3636 12.8086 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84984L11.5469 16.2561C11.3423 16.4606 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4606 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0302C4.28551 9.74899 4.38778 9.50609 4.59233 9.30154L5.99858 7.89529C6.20312 7.69075 6.44602 7.58848 6.72727 7.58848C7.00852 7.58848 7.25142 7.69075 7.45597 7.89529L10.8182 11.2575L19.0895 2.9862C19.294 2.78166 19.5369 2.67939 19.8182 2.67939C20.0994 2.67939 20.3423 2.78166 20.5469 2.9862L21.9531 4.39245C22.1577 4.597 22.2599 4.8399 22.2599 5.12115C22.2599 5.4024 22.1577 5.64529 21.9531 5.84984Z",
                            fill: "#1266F1",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("strong", { staticClass: "font-size-125" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "Up to %aiTasks% AI-supported tasks",
                            { "%aiTasks%": 350 },
                            "general"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "pricing-card-large-button",
                    class: { disabled: _vm.isActiveSubscription },
                    attrs: { disabled: _vm.isActiveSubscription },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.goToChoosePayment("subscription", 480)
                      },
                    },
                  },
                  [
                    _vm.isStatusLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-center",
                          },
                          [
                            _c("span", {
                              staticClass: "spin-circle-basic spin-circle-175",
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isStatusDone
                      ? _c("strong", { staticClass: "font-size-125" }, [
                          _vm._v(_vm._s(_vm._f("trans")("Subscribe"))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "15",
                          height: "12",
                          viewBox: "0 0 15 12",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M14.0373 6.70597C14.4278 6.3155 14.4278 5.68137 14.0373 5.2909L9.03928 0.292854C8.6488 -0.0976181 8.01468 -0.0976181 7.6242 0.292854C7.23373 0.683327 7.23373 1.31745 7.6242 1.70793L10.9198 5.00039H1.33604C0.783126 5.00039 0.336426 5.44709 0.336426 6C0.336426 6.55291 0.783126 6.99961 1.33604 6.99961H10.9167L7.62733 10.2921C7.23685 10.6825 7.23685 11.3167 7.62733 11.7071C8.0178 12.0976 8.65193 12.0976 9.0424 11.7071L14.0404 6.7091L14.0373 6.70597Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pricing-card-container" }, [
            _c("div", { staticClass: "pricing-card bg-white" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-between flex-wrap" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex gap-5",
                      staticStyle: { height: "max-content" },
                    },
                    [
                      _c("div", { staticClass: "icon-box" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewbox: "0 0 16 16",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M8.00016 3.33331C9.72816 3.33331 11.3242 3.64331 12.5135 4.17198C13.1068 4.43598 13.6295 4.76731 14.0115 5.16931C14.3975 5.57331 14.6668 6.08131 14.6668 6.66665V9.33331C14.6668 9.91865 14.3975 10.426 14.0115 10.8306C13.6295 11.2326 13.1075 11.564 12.5135 11.828C11.3242 12.3566 9.72816 12.6666 8.00016 12.6666C6.27216 12.6666 4.67616 12.3566 3.48683 11.828C2.8935 11.564 2.37083 11.2326 1.98883 10.8306C1.60283 10.4266 1.3335 9.91865 1.3335 9.33331V6.66665C1.3335 6.08131 1.60283 5.57398 1.98883 5.16931C2.37083 4.76731 2.89283 4.43598 3.48683 4.17198C4.67616 3.64331 6.27216 3.33331 8.00016 3.33331ZM13.3335 8.71998C13.0835 8.88398 12.8068 9.03065 12.5135 9.16131C11.3242 9.68998 9.72816 9.99998 8.00016 9.99998C6.27216 9.99998 4.67616 9.68998 3.48683 9.16131C3.2021 9.03645 2.92788 8.88886 2.66683 8.71998V9.33331C2.66683 9.48465 2.7335 9.67865 2.95483 9.91198C3.1795 10.148 3.53616 10.3913 4.02816 10.61C5.01083 11.0466 6.41483 11.3333 8.00016 11.3333C9.58616 11.3333 10.9895 11.0466 11.9722 10.61C12.4642 10.3913 12.8208 10.148 13.0455 9.91198C13.2675 9.67865 13.3335 9.48465 13.3335 9.33331V8.71998ZM8.00016 4.66665C6.41416 4.66665 5.01083 4.95331 4.02816 5.38998C3.53616 5.60865 3.1795 5.85198 2.95483 6.08798C2.73283 6.32131 2.66683 6.51531 2.66683 6.66665C2.66683 6.81798 2.7335 7.01198 2.95483 7.24531C3.1795 7.48131 3.53616 7.72465 4.02816 7.94331C5.01083 8.37998 6.41483 8.66665 8.00016 8.66665C9.58616 8.66665 10.9895 8.37998 11.9722 7.94331C12.4642 7.72465 12.8208 7.48131 13.0455 7.24531C13.2675 7.01198 13.3335 6.81798 13.3335 6.66665C13.3335 6.51531 13.2668 6.32131 13.0455 6.08798C12.8208 5.85198 12.4642 5.60865 11.9722 5.38998C10.9895 4.95398 9.5855 4.66665 8.00016 4.66665Z",
                                fill: "#2E2E2E",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("strong", { staticClass: "font-size-125" }, [
                        _vm._v(
                          _vm._s(_vm.subscription10000.monthly_credits) +
                            " " +
                            _vm._s(_vm._f("trans")("Credits"))
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "end" } }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(
                          _vm.productPriceString(_vm.subscription10000.price)
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("trans")("Monthly Subscription"))),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Frequent Use")))]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-column gap-20" }, [
                _c("div", [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "For power users who rely heavily on our service. Maximize efficiency and savings with our high-volume subscription package."
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Streamline your workflow and stay ahead."
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex gap-10" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "22",
                        viewbox: "0 0 24 22",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53024C1 4.51603 1.36009 3.64885 2.08026 2.92867C2.80043 2.2085 3.66761 1.84842 4.68182 1.84842H15.3182C15.8551 1.84842 16.3537 1.95495 16.8139 2.16802C16.9418 2.22768 17.0185 2.32569 17.044 2.46206C17.0696 2.60694 17.0312 2.73052 16.929 2.83279L16.3026 3.45921C16.2173 3.54444 16.1193 3.58706 16.0085 3.58706C15.983 3.58706 15.9446 3.57853 15.8935 3.56149C15.6974 3.51035 15.5057 3.48478 15.3182 3.48478H4.68182C4.11932 3.48478 3.63778 3.68507 3.23722 4.08564C2.83665 4.4862 2.63636 4.96774 2.63636 5.53024V16.1666C2.63636 16.7291 2.83665 17.2106 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2106 17.3636 16.7291 17.3636 16.1666V12.9194C17.3636 12.8086 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84984L11.5469 16.2561C11.3423 16.4606 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4606 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0302C4.28551 9.74899 4.38778 9.50609 4.59233 9.30154L5.99858 7.89529C6.20312 7.69075 6.44602 7.58848 6.72727 7.58848C7.00852 7.58848 7.25142 7.69075 7.45597 7.89529L10.8182 11.2575L19.0895 2.9862C19.294 2.78166 19.5369 2.67939 19.8182 2.67939C20.0994 2.67939 20.3423 2.78166 20.5469 2.9862L21.9531 4.39245C22.1577 4.597 22.2599 4.8399 22.2599 5.12115C22.2599 5.4024 22.1577 5.64529 21.9531 5.84984Z",
                          fill: "#1266F1",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", { staticClass: "font-size-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Up to %creditCount% tasks",
                          {
                            "%creditCount%":
                              _vm.subscription10000.monthly_credits,
                          },
                          "general"
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex gap-10" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "22",
                        viewbox: "0 0 24 22",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 12.1013V16.1666C19 17.1808 18.6399 18.048 17.9197 18.7682C17.1996 19.4883 16.3324 19.8484 15.3182 19.8484H4.68182C3.66761 19.8484 2.80043 19.4883 2.08026 18.7682C1.36009 18.048 1 17.1808 1 16.1666V5.53024C1 4.51603 1.36009 3.64885 2.08026 2.92867C2.80043 2.2085 3.66761 1.84842 4.68182 1.84842H15.3182C15.8551 1.84842 16.3537 1.95495 16.8139 2.16802C16.9418 2.22768 17.0185 2.32569 17.044 2.46206C17.0696 2.60694 17.0312 2.73052 16.929 2.83279L16.3026 3.45921C16.2173 3.54444 16.1193 3.58706 16.0085 3.58706C15.983 3.58706 15.9446 3.57853 15.8935 3.56149C15.6974 3.51035 15.5057 3.48478 15.3182 3.48478H4.68182C4.11932 3.48478 3.63778 3.68507 3.23722 4.08564C2.83665 4.4862 2.63636 4.96774 2.63636 5.53024V16.1666C2.63636 16.7291 2.83665 17.2106 3.23722 17.6112C3.63778 18.0118 4.11932 18.2121 4.68182 18.2121H15.3182C15.8807 18.2121 16.3622 18.0118 16.7628 17.6112C17.1634 17.2106 17.3636 16.7291 17.3636 16.1666V12.9194C17.3636 12.8086 17.402 12.7149 17.4787 12.6382L18.2969 11.82C18.3821 11.7348 18.4801 11.6922 18.5909 11.6922C18.642 11.6922 18.6932 11.705 18.7443 11.7305C18.9148 11.7987 19 11.9223 19 12.1013ZM21.9531 5.84984L11.5469 16.2561C11.3423 16.4606 11.0994 16.5629 10.8182 16.5629C10.5369 16.5629 10.294 16.4606 10.0895 16.2561L4.59233 10.7589C4.38778 10.5544 4.28551 10.3115 4.28551 10.0302C4.28551 9.74899 4.38778 9.50609 4.59233 9.30154L5.99858 7.89529C6.20312 7.69075 6.44602 7.58848 6.72727 7.58848C7.00852 7.58848 7.25142 7.69075 7.45597 7.89529L10.8182 11.2575L19.0895 2.9862C19.294 2.78166 19.5369 2.67939 19.8182 2.67939C20.0994 2.67939 20.3423 2.78166 20.5469 2.9862L21.9531 4.39245C22.1577 4.597 22.2599 4.8399 22.2599 5.12115C22.2599 5.4024 22.1577 5.64529 21.9531 5.84984Z",
                          fill: "#1266F1",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", { staticClass: "font-size-125" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("trans")(
                          "Up to %aiTasks% AI-supported tasks",
                          { "%aiTasks%": 1250 },
                          "general"
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "pricing-card-large-button",
                  class: { disabled: _vm.isActiveSubscription },
                  attrs: { disabled: _vm.isActiveSubscription },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToChoosePayment("subscription", 2800)
                    },
                  },
                },
                [
                  _vm.isStatusLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-center",
                        },
                        [
                          _c("span", {
                            staticClass: "spin-circle-basic spin-circle-175",
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isStatusDone
                    ? _c("strong", { staticClass: "font-size-125" }, [
                        _vm._v(_vm._s(_vm._f("trans")("Subscribe"))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "12",
                        viewBox: "0 0 15 12",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M14.0373 6.70597C14.4278 6.3155 14.4278 5.68137 14.0373 5.2909L9.03928 0.292854C8.6488 -0.0976181 8.01468 -0.0976181 7.6242 0.292854C7.23373 0.683327 7.23373 1.31745 7.6242 1.70793L10.9198 5.00039H1.33604C0.783126 5.00039 0.336426 5.44709 0.336426 6C0.336426 6.55291 0.783126 6.99961 1.33604 6.99961H10.9167L7.62733 10.2921C7.23685 10.6825 7.23685 11.3167 7.62733 11.7071C8.0178 12.0976 8.65193 12.0976 9.0424 11.7071L14.0404 6.7091L14.0373 6.70597Z",
                          fill: "white",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "explore-btn",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.goToPricingPage.apply(null, arguments)
            },
          },
        },
        [
          _c("strong", { staticClass: "font-size-125" }, [
            _vm._v(_vm._s(_vm._f("trans")("Explore All Options"))),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "12",
                viewBox: "0 0 15 12",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14.2038 6.70597C14.5943 6.3155 14.5943 5.68137 14.2038 5.2909L9.20578 0.292854C8.81531 -0.0976181 8.18118 -0.0976181 7.79071 0.292854C7.40024 0.683327 7.40024 1.31745 7.79071 1.70793L11.0863 5.00039H1.50254C0.94963 5.00039 0.50293 5.44709 0.50293 6C0.50293 6.55291 0.94963 6.99961 1.50254 6.99961H11.0832L7.79383 10.2921C7.40336 10.6825 7.40336 11.3167 7.79383 11.7071C8.1843 12.0976 8.81843 12.0976 9.2089 11.7071L14.207 6.7091L14.2038 6.70597Z",
                  fill: "#1266F1",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }